<template>
  <div>
    <Header />
    <section
      id="comparer_form"
      class="px-4 pt-16 pb-32 overflow-hidden bg-gray-100"
    >
      <div class="max-w-6xl mx-auto">
        <ValidationObserver ref="form" style="display: block">
          <form class="flex" @submit.prevent="onSubmit()">
            <div class="md:w-3/4 w-full">
              <div class="md:flex punkta_comparer_user_data">
                <div class="text-2xl md:w-1/3 mb-7 md:mb-0">
                  Dane ubezpieczającego
                </div>
                <div class="md:w-2/3 punkta_comparer_userbol">
                  <div>
                    <validation-provider
                      rules="required|numeric|max:11|valid_pesel"
                      v-slot="{ errors, pristine }"
                    >
                      <div class="relative md:w-4/5 mb-5">
                        <input
                          class="w-full p-5 pr-10 text-sm placeholder-black bg-white rounded shadow-0-2-5"
                          type="text"
                          placeholder="PESEL"
                          name="clientPesel"
                          v-model="clientPesel"
                          @click="
                            sendEvent({
                              event: 'travelInsuranceCalculator',
                              action: 'Field Click',
                              label: '3 Step - PESEL'
                            })
                          "
                        />
                        <StatusInput
                          v-if="!pristine || errors[0] ? true : false"
                          :passed="errors[0] ? false : true"
                        />
                      </div>

                      <div class="error text-red-100 text-sm relative ">
                        {{ errors[0] }}
                      </div>
                    </validation-provider>
                    <validation-provider
                      :rules="{
                        required: true,
                        regex: /^[0-9]{2}-[0-9]{3}$/
                      }"
                      v-slot="{ errors, pristine }"
                    >
                      <div class="relative md:w-4/5 mb-5">
                        <input
                          class="w-full p-5 pr-10 text-sm placeholder-black bg-white rounded shadow-0-2-5"
                          type="text"
                          v-model="place_of_stay.postal_code"
                          name="place_of_stay_postal_code"
                          placeholder="Kod pocztowy"
                          @click="
                            sendEvent({
                              event: 'travelInsuranceCalculator',
                              action: 'Field Click',
                              label: '3 Step - Kod pocztowy'
                            })
                          "
                        />
                        <StatusInput
                          v-if="!pristine || errors[0] ? true : false"
                          :passed="errors[0] ? false : true"
                        />
                      </div>

                      <div class="error text-red-100 text-sm relative ">
                        {{ errors[0] }}
                      </div>
                    </validation-provider>
                    <validation-provider
                      :rules="{
                        required: true
                      }"
                      v-slot="{ errors, pristine }"
                    >
                      <div class="relative md:w-4/5 mb-5">
                        <input
                          class="w-full p-5 pr-10 text-sm placeholder-black bg-white rounded shadow-0-2-5"
                          type="text"
                          v-model="place_of_stay.city"
                          name="place_of_stay_city"
                          placeholder="Miejscowość"
                          @click="
                            sendEvent({
                              event: 'travelInsuranceCalculator',
                              action: 'Field Click',
                              label: '3 Step - Miejscowość'
                            })
                          "
                        />
                        <StatusInput
                          v-if="!pristine || errors[0] ? true : false"
                          :passed="errors[0] ? false : true"
                        />
                      </div>

                      <div class="error text-red-100 text-sm relative ">
                        {{ errors[0] }}
                      </div>
                    </validation-provider>

                    <validation-provider
                      :rules="{
                        required: true
                      }"
                      v-slot="{ errors, pristine }"
                    >
                      <div class="relative md:w-4/5 mb-5">
                        <input
                          class="w-full p-5 pr-10 text-sm placeholder-black bg-white rounded shadow-0-2-5"
                          type="text"
                          v-model="place_of_stay.street"
                          name="place_of_stay_street"
                          placeholder="Ulica"
                          @click="
                            sendEvent({
                              event: 'travelInsuranceCalculator',
                              action: 'Field Click',
                              label: '3 Step - Ulica'
                            })
                          "
                        />
                        <StatusInput
                          v-if="!pristine || errors[0] ? true : false"
                          :passed="errors[0] ? false : true"
                        />
                      </div>

                      <div class="error text-red-100 text-sm relative ">
                        {{ errors[0] }}
                      </div>
                    </validation-provider>
                    <validation-provider
                      :rules="{
                        required: true
                      }"
                      v-slot="{ errors, pristine }"
                    >
                      <div class="relative md:w-4/5 mb-5">
                        <input
                          class="w-full p-5 pr-10 text-sm placeholder-black bg-white rounded shadow-0-2-5"
                          type="text"
                          v-model="place_of_stay.street_number"
                          name="place_of_stay_street_number"
                          placeholder="Numer domu"
                          @click="
                            sendEvent({
                              event: 'travelInsuranceCalculator',
                              action: 'Field Click',
                              label: '3 Step - Numer domu'
                            })
                          "
                        />
                        <StatusInput
                          v-if="!pristine || errors[0] ? true : false"
                          :passed="errors[0] ? false : true"
                        />
                      </div>

                      <div class="error text-red-100 text-sm relative ">
                        {{ errors[0] }}
                      </div>
                    </validation-provider>

                    <validation-provider v-slot="{ errors, pristine }">
                      <div class="relative md:w-4/5 mb-5">
                        <input
                          class="w-full p-5 pr-10 text-sm placeholder-black bg-white rounded shadow-0-2-5"
                          type="text"
                          v-model="place_of_stay.flat_number"
                          name="place_of_stay_flat_number"
                          placeholder="Numer mieszkania"
                          @click="
                            sendEvent({
                              event: 'travelInsuranceCalculator',
                              action: 'Field Click',
                              label: '3 Step - Numer mieszkania'
                            })
                          "
                        />
                        <StatusInput
                          v-if="!pristine || errors[0] ? true : false"
                          :passed="errors[0] ? false : true"
                        />
                      </div>

                      <div class="error text-red-100 text-sm relative ">
                        {{ errors[0] }}
                      </div>
                    </validation-provider>
                  </div>
                </div>
              </div>

              <div class="md:flex">
                <div class="md:w-1/3"></div>
                <div class="md:w-2/3">
                  <div class="flex justify-between w-full md:w-4/5">
                    <router-link
                      to="/offers"
                      class="flex justify-center w-32 py-4 text-xs font-bold text-black border border-black rounded-lg comparer-button text-opacity-60 border-opacity-20 md:w-40"
                    >
                      <svg
                        class="self-center mx-1 svg-button"
                        width="16"
                        height="6"
                        viewBox="0 0 16 6"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M0.556272 3.32599C0.591976 3.43105 0.645515 3.52704 0.713812 3.60844L2.58928 5.74828C2.73054 5.90945 2.92214 6 3.12191 6C3.32169 6 3.51328 5.90945 3.65454 5.74828C3.79581 5.5871 3.87517 5.3685 3.87517 5.14056C3.87517 4.91263 3.79581 4.69403 3.65454 4.53285L3.05439 3.85666L14.7498 3.85666C14.9488 3.85666 15.1396 3.76649 15.2803 3.60597C15.421 3.44545 15.5 3.22774 15.5 3.00073C15.5 2.77372 15.421 2.55601 15.2803 2.3955C15.1396 2.23498 14.9488 2.1448 14.7498 2.1448L3.0544 2.1448L3.65454 1.46861C3.72486 1.38904 3.78067 1.29437 3.81876 1.19007C3.85684 1.08577 3.87645 0.973891 3.87645 0.860897C3.87645 0.747904 3.85684 0.636029 3.81876 0.531725C3.78067 0.427422 3.72486 0.332755 3.65454 0.253185C3.58481 0.172959 3.50183 0.109283 3.41042 0.0658282C3.319 0.0223736 3.22095 8.3388e-07 3.12191 8.25222e-07C3.02288 8.16564e-07 2.92483 0.0223735 2.83341 0.0658282C2.74199 0.109283 2.65902 0.172959 2.58928 0.253185L0.713812 2.39302C0.645515 2.47442 0.591976 2.57041 0.556272 2.67548C0.48124 2.88386 0.48124 3.1176 0.556272 3.32599Z"
                          fill="black"
                        />
                      </svg>
                      <div class="mx-1">Wstecz</div></router-link
                    >

                    <button
                      type="submit"
                      class="flex justify-center w-32 py-4 text-xs font-bold text-white bg-orange-100 rounded-lg comparer-button md:w-40"
                    >
                      <div class="mx-1">Dalej</div>
                      <svg
                        class="self-center mx-1"
                        width="15"
                        height="6"
                        viewBox="0 0 15 6"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M14.9437 2.67401C14.908 2.56895 14.8545 2.47296 14.7862 2.39156L12.9107 0.251722C12.7695 0.0905471 12.5779 0 12.3781 0C12.1783 0 11.9867 0.0905471 11.8455 0.251722C11.7042 0.412898 11.6248 0.631499 11.6248 0.859435C11.6248 1.08737 11.7042 1.30597 11.8455 1.46715L12.4456 2.14334H0.750187C0.551225 2.14334 0.360412 2.23351 0.219725 2.39403C0.0790375 2.55455 0 2.77226 0 2.99927C0 3.22628 0.0790375 3.44399 0.219725 3.6045C0.360412 3.76502 0.551225 3.8552 0.750187 3.8552H12.4456L11.8455 4.53139C11.7751 4.61096 11.7193 4.70563 11.6812 4.80993C11.6432 4.91423 11.6236 5.02611 11.6236 5.1391C11.6236 5.2521 11.6432 5.36397 11.6812 5.46827C11.7193 5.57258 11.7751 5.66724 11.8455 5.74681C11.9152 5.82704 11.9982 5.89072 12.0896 5.93417C12.181 5.97763 12.2791 6 12.3781 6C12.4771 6 12.5752 5.97763 12.6666 5.93417C12.758 5.89072 12.841 5.82704 12.9107 5.74681L14.7862 3.60698C14.8545 3.52558 14.908 3.42959 14.9437 3.32452C15.0188 3.11614 15.0188 2.8824 14.9437 2.67401Z"
                          fill="white"
                        />
                      </svg>
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <Chat />
          </form>
        </ValidationObserver>
      </div>
    </section>
  </div>
</template>

<script>
import Header from './components/Header.vue'
import Chat from './components/Chat.vue'
import StatusInput from './components/StatusInput.vue'

export default {
  components: {
    Header,
    Chat,
    StatusInput
  },
  data () {
    return {
      clientPesel: '',
      place_of_stay: {
        street: '',
        street_number: '',
        postal_code: '',
        city: '',
        flat_number: ''
      }
    }
  },

  mounted () {
    this.$store.commit('setStep', 2)
    window.scrollTo(0, 0)
    this.clientPesel = this.$store.state.clientPesel
    if (this.$store.state.starpack && this.$store.state.starpack.result_info) {
      this.sendEmail()
    }
    if (
      this.$store.state.addresses &&
      this.$store.state.addresses[1] &&
      this.$store.state.addresses[1].place_of_stay
    ) {
      this.place_of_stay = this.$store.state.addresses[1].place_of_stay
    }

    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({ ecommerce: null })
    window.dataLayer.push({
      event: 'travelInsuranceCalculator', //stała
      action: 'ecommerce', //stała
      label: 'checkout - 1', //stała wartość checkout + krok checkout
      ecommerce: {
        currencyCode: 'PLN', //stała
        checkout: {
          actionField: {
            step: 1 //stała
          }
        },
        products: [this.$store.state.starpackEvent]
      }
    })
  },
  methods: {
    onSubmit () {
      this.$refs.form.validate().then(success => {
        if (!success) {
          const errors = Object.entries(this.$refs.form.errors)
          .map(([key, value]) => ({ key, value }))
          .filter(error => error["value"].length);
          if(this.$refs.form.refs[errors[0]["key"]]){
            this.$refs.form.refs[errors[0]["key"]].$el.scrollIntoView({
            behavior: "smooth",
            block: "start"
            });
          }
          return
        }
        let _this = this

        _this.$store.commit('setAddresses', [
          { place_of_residence: this.$data.place_of_stay },
          { place_of_stay: this.$data.place_of_stay }
        ])
        _this.$store.commit('setclientPesel', this.clientPesel)
        _this.updateLead()
        this.$router.push('/summary')
        // _this.getPolicy(_this.$store.state.starpack)
      })
    },
    updateLead () {
      let _this = this
      this.axios
        .post('/wp-json/travel/v1/updateLead', {
          lead: {
            salesforce_id: _this.$store.state.leadSalesforceId,
            calculation_token: _this.$store.state.calculationToken,
            pesel: _this.clientPesel,
            billing_postal_code: _this.place_of_stay.postal_code,
            billing_city: _this.place_of_stay.city,
            billing_street: _this.place_of_stay.street + ' ' + _this.place_of_stay.street_number + ' / ' + _this.place_of_stay.flat_number ,
          }
        })
        .catch(function (error) {
          console.log(error)
          // _this.$store.commit('setShowModal', true)
        })
    },
    sendEvent (value) {
      window.dataLayer = window.dataLayer || []
      window.dataLayer.push(value)
    },
    sendEmail () {
      let _this = this
      _this.$store.commit('setLoader', true)
      this.axios
        .post('/wp-json/travel/v1/sendEmail', {
          event_name: 'travel_policy_offer_documents',
          tu_name: _this.$store.state.starpack.result_info.name,
          attributes: {
            event: {
              uuid: _this.$store.state.starpack.uuid,
              receiver: _this.$store.state.clientEmail,
              app: 'travel',
              event_name: 'travel_policy_offer_documents',
              server: 'wp'
            },
            payload: {
              tu_name: _this.$store.state.starpack.result_info.name,
              tu_logo_url: 'Logo ubezpieczyciela (url)',
              policy_price: '' + _this.$store.state.starpack.price,
              policy_start_date: _this.$store.state.dateFrom,
              policy_end_date: _this.$store.state.dateTo
            }
          }
        })
        .then(function (response) {
          if (response && response.data && response.data.success) {
            _this.$store.commit('setLoader', false)
          }
        })
        .catch(function (error) {
          console.log(error)
          _this.$store.commit('setLoader', false)
          _this.$store.commit('setShowModal', true)
        })
    }
  }
}
</script>
